<template>
<ItpPage
  :size="size"
  :header="documentTitle"
  :loaded="loaded"
  :noShow="!loaded"
  :modal="modal"
  itp-cname="InvoicingProviderSettings"
  :modalBindings="b_7315092382398562_modalBindings"
  @close="evh_7315092382398562_close($event, {})"
>
  <UcHeader
    :card="!modal"
    :modal="modal"
    :title="documentTitle"
    slot="header"
    v-if="loaded"
    @close="evh_2248226175642056_close($event, {})"
  >
  </UcHeader>
  <UcBody
    :card="!modal"
    :modal="modal"
    v-if="loaded"
  >
    <ItpForm
      :name="formName"
      :labelAlign="$config.forms.defaultLabelAlign"
      :id="formId"
      @submit="evh_1040167445267876_submit($event, {})"
    >
      <ItpRow>
        <ItpCol>
          <ItpFormGroup
            labelColsMd="3"
            contentColsMd="9"
            name="name"
            :label="'Name'|pgettext('InvoicingProviderSettings')"
            required
          >
            <b-form-input
              plaintext
              v-model="settings.name"
              class="font-weight-bold no-focus-border"
            >
            </b-form-input>
          </ItpFormGroup>
          <ItpFormGroup
            labelColsMd="3"
            contentColsMd="9"
            name="url"
            :label="'URL'|pgettext('InvoicingProviderSettings')"
            :helpTooltip="'The root URL of the service.'|pgettext('InvoicingProviderSettings')"
            required
          >
            <ItpFormInput
              name="url"
              v-model="settings.url"
              required
            >
            </ItpFormInput>
          </ItpFormGroup>
          <ItpFormGroup
            labelColsMd="3"
            contentColsMd="9"
            name="invoice_prefix"
            :label="'Invoice prefix'|pgettext('InvoicingProviderSettings')"
            required
            :helpTooltip="'The invoice prefix set up by the provider.'|pgettext('InvoicingProviderSettings')"
          >
            <ItpFormInput
              name="invoice_prefix"
              v-model="settings.invoice_prefix"
              required
            >
            </ItpFormInput>
          </ItpFormGroup>
          <ItpFormGroup
            labelColsMd="3"
            contentColsMd="9"
            name="username"
            :label="'Username'|pgettext('InvoicingProviderSettings')"
            :helpTooltip="'The technical user\'s name.'|pgettext('InvoicingProviderSettings')"
            required
          >
            <ItpFormInput
              name="username"
              v-model="settings.username"
              required
            >
            </ItpFormInput>
          </ItpFormGroup>
          <ItpFormGroup
            labelColsMd="3"
            contentColsMd="9"
            name="agent_key"
            :label="'Agent key'|pgettext('InvoicingProviderSettings')"
            :helpTooltip="'The technical user\'s agent key.'|pgettext('InvoicingProviderSettings')"
            required
          >
            <ItpFormInput
              name="agent_key"
              v-model="settings.agent_key"
              required
            >
            </ItpFormInput>
          </ItpFormGroup>
          <ItpFormGroup
            labelColsMd="3"
            contentColsMd="9"
            name="invoice_template"
            :label="'Invoice template'|pgettext('InvoicingProviderSettings')"
            :helpTooltip="'The ID/key of the invoice template.'|pgettext('InvoicingProviderSettings')"
          >
            <ItpFormInput
              name="invoice_template"
              v-model="settings.invoice_template"
            >
            </ItpFormInput>
          </ItpFormGroup>
          <ItpFormGroup
            labelColsMd="3"
            contentColsMd="9"
            name="invoice_notes"
            :label="'Invoice notes'|pgettext('InvoicingProviderSettings')"
            :helpTooltip="'General notes to append to all invoices.'|pgettext('InvoicingProviderSettings')"
          >
            <ItpFormTextarea
              name="invoice_notes"
              v-model="settings.invoice_notes"
            >
            </ItpFormTextarea>
          </ItpFormGroup>
          <ItpFormGroup
            labelColsMd="3"
            contentColsMd="9"
            name="invoice_notes"
            :label="'Send email notifications'|pgettext('InvoicingProviderSettings')"
            :helpTooltip="'Send email notifications from the provider service.'|pgettext('InvoicingProviderSettings')"
          >
            <ItpFormCheckbox
              name="send_email"
              v-model="settings.send_email"
            >
            </ItpFormCheckbox>
          </ItpFormGroup>
        </ItpCol>
      </ItpRow>
    </ItpForm>
  </UcBody>
  <UcFooter
    :card="!modal"
    :modal="modal"
    slot="footer"
    v-if="loaded"
  >
    <ItpButton
      :form="forms[formName] && forms[formName].id"
      :text="'Save'|pgettext('Button')"
      type="submit"
      variant="primary"
      default
      :spinning="actions.submit && actions.submit.isRunning"
    >
    </ItpButton>
    <ItpButton
      :text="'Close'|pgettext('Button')"
      variant="default"
      :disabled="actions.submit && actions.submit.isRunning"
      @click.prevent.stop="evh_1419464017721962_clickPreventStop($event, {})"
    >
    </ItpButton>
  </UcFooter>
  <template
    slot="footer"
    v-if="loaded"
  >
  </template>
</ItpPage>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class InvoicingProviderSettings extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "page",
  };

  beforeCreate() {
  }

  @Prop({
    required: true,
    type: Object,
  })
  item!: object;

  @Watch('item')
  onItem(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("item")
  }

  @Prop({
    required: true,
    type: Object,
  })
  saving!: object;

  @Watch('saving')
  onSaving(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("saving")
  }

  @Prop({
    type: String,
    default: "lg",
  })
  size!: string;

  @Watch('size')
  onSize(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("size")
  }

  formId!: any;

  async $$load_formId() {
    return this.$fn.randomElementId()
  }

  formName!: any;
  defaultSettings!: any;
  settings!: any;

  async $$load_settings() {
    return _.extend(this.defaultSettings, this.item)
  }

  ux!: any;
  b_7315092382398562_modalBindings!: any;
  dataMembers = ['formId', 'formName', 'defaultSettings', 'settings', 'ux', 'b_7315092382398562_modalBindings'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        formId: null,
        formName: "InvoicingProviderSettings",
        defaultSettings: {
          target_type: "szamlazz_hu",
          name: "default",
          url: null,
          invoice_prefix: null,
          username: null,
          agent_key: null,
        }
        ,
        settings: null,
        ux: null,
        b_7315092382398562_modalBindings: {
          size: "lg",
        }
        ,
      },
    }
  }

  get document() {
    if (this.loaded) {

      return {
        title: [this.$fn.pgettext("InvoicingProviderSettings|Title", "Invoicing provider configuration")
          ,
        ]
        ,
        icon: this.$config.settings.icon,
      }
    }
    return null;
  }

  async act_7315092382398562_closeModal_4948_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_7315092382398562_closeModal_4948, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
        cancel: true,
      }
      ,
    }
  }

  async evh_7315092382398562_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
  }

  async evh_2248226175642056_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
  }

  async act_1040167445267876_script_4952_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_1040167445267876_script_4952, alias=submit
    this.saving(this.settings).then(result => this.$imodal.close(this.modalName, { ok: true, value: result }))
  }

  async act_1040167445267876_script_4952_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_1040167445267876_script_4952, alias=submit
    return {
      value: () => this.act_1040167445267876_script_4952_getActionArgs_value($event),
    }
  }

  async evh_1040167445267876_submit(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1040167445267876_submit.executeFromDOM(this, event, scope);
  }

  async act_1419464017721962_closeModal_4954_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_1419464017721962_closeModal_4954, alias=undefined
    return {
      name: this.modalName,
    }
  }

  async evh_1419464017721962_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1419464017721962_clickPreventStop.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_closeModal_4948: actions.CloseModalAction;
    evh_7315092382398562_close_4947: actions.EventHandlerImpl;
    evh_7315092382398562_close: actions.EventHandlerGroup;
    act_2248226175642056_closeComponent_4950: actions.CloseComponentAction;
    evh_2248226175642056_close_4949: actions.EventHandlerImpl;
    evh_2248226175642056_close: actions.EventHandlerGroup;
    act_1040167445267876_script_4952: actions.ScriptAction;
    evh_1040167445267876_submit_4951: actions.EventHandlerImpl;
    evh_1040167445267876_submit: actions.EventHandlerGroup;
    act_1419464017721962_closeModal_4954: actions.CloseModalAction;
    evh_1419464017721962_clickPreventStop_4953: actions.EventHandlerImpl;
    evh_1419464017721962_clickPreventStop: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_closeModal_4948 = new actions.CloseModalAction(
      {
        actionArgs: this.act_7315092382398562_closeModal_4948_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_close_4947 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_closeModal_4948,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_7315092382398562_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_close_4947],
      }
    );
    const act_2248226175642056_closeComponent_4950 = new actions.CloseComponentAction(
      {
        events: [],
      }
    );
    const evh_2248226175642056_close_4949 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_closeComponent_4950,
        event: "close",
        displayName: "closeComponent",
      }
    );
    const evh_2248226175642056_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_2248226175642056_close_4949],
      }
    );
    const act_1040167445267876_script_4952 = new actions.ScriptAction(
      {
        actionArgs: this.act_1040167445267876_script_4952_getActionArgs,
        displayName: "submit",
        events: [],
      }
    );
    const evh_1040167445267876_submit_4951 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_script_4952,
        event: "submit",
        displayName: "submit",
      }
    );
    const evh_1040167445267876_submit = new actions.EventHandlerGroup(
      {
        handlers: [evh_1040167445267876_submit_4951],
      }
    );
    const act_1419464017721962_closeModal_4954 = new actions.CloseModalAction(
      {
        actionArgs: this.act_1419464017721962_closeModal_4954_getActionArgs,
        events: [],
      }
    );
    const evh_1419464017721962_clickPreventStop_4953 = new actions.EventHandlerImpl(
      {
        action: act_1419464017721962_closeModal_4954,
        event: "click.prevent.stop",
        displayName: "closeModal",
      }
    );
    const evh_1419464017721962_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_1419464017721962_clickPreventStop_4953],
      }
    );
    return {
      act_7315092382398562_closeModal_4948,
      evh_7315092382398562_close_4947,
      evh_7315092382398562_close,
      act_2248226175642056_closeComponent_4950,
      evh_2248226175642056_close_4949,
      evh_2248226175642056_close,
      act_1040167445267876_script_4952,
      evh_1040167445267876_submit_4951,
      evh_1040167445267876_submit,
      act_1419464017721962_closeModal_4954,
      evh_1419464017721962_clickPreventStop_4953,
      evh_1419464017721962_clickPreventStop,
      submit: act_1040167445267876_script_4952,
    }
  }
}

Vue.component("InvoicingProviderSettings", InvoicingProviderSettings);

</script>